<template>
  <div
    :class="{
      'tm-country': true,
      'tm-country--disabled': disabled,
    }"
  >
    <tm-flag
      class="tm-country__flag"
      :country-code="countryCode"
      :size="size"
    />
    <div
      v-if="!hideTitle || countryCode"
      class="tm-country-text"
    >
      <slot
        name="title"
        :title="cTitle"
      >
        <span
          v-if="!hideTitle"
          class="tm-country__title"
          :class="{
            [`tm-country__title--font-${fontWeight}`]: fontWeight,
          }"
          :title="showTooltip ? cTitle : ''"
        >
          {{ cTitle }}
        </span>
      </slot>
      <span
        v-if="additionalData"
        class="tm-country__additional-data"
      >
        {{ `(${additionalData})` }}
      </span>
    </div>
    <slot name="separator" />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, type PropType } from '@/composition/vue/compositionApi'
import TmFlag from '@/components/shared/TmFlag.vue'
import type { FlagSize, SizeProp } from '@/components/shared/types'
import { type TmCountryCode, TmFakeCountryCode } from '@/services/types'
import { getCountryService } from '@/core/container/ioc'

export default defineComponent({
  components: {
    TmFlag,
  },
  props: {
    hideTitle: {
      type: Boolean,
    },
    countryCode: {
      type: String as PropType<TmCountryCode>,
      default: TmFakeCountryCode,
    },
    title: {
      type: String,
    },
    showTooltip: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String as SizeProp<FlagSize>,
      default: '',
    },
    additionalData: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
    },
    fontWeight: {
      type: String,
    },
  },
  setup(props) {
    const countryService = getCountryService()

    const cTitle = computed(() => {
      if (props.title) return props.title
      return props.countryCode ? countryService.getCountryName(props.countryCode) : ''
    })

    return {
      cTitle,
    }
  },
})
</script>

<style lang="scss" scoped>
.tm-country {
  display: flex;
  width: 100%;
  align-items: center;
  color: $emphasize;
  &-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.2;
  }
  &__flag:not(:last-child) {
    margin-right: 8px;
  }
  &__additional-data {
    padding-left: 4px;
    color: $distinct;
  }

  &--disabled {
    color: $gray5;
  }

  &--disabled &__flag {
    opacity: 0.5;
  }

  &__title--font-medium {
    font-weight: $medium-font;
  }
}
</style>
